import { Button } from "flowbite-react/lib/esm/components/Button/Button";
import { DarkThemeToggle } from "flowbite-react/lib/esm/components/DarkThemeToggle/DarkThemeToggle";
import { Navbar } from "flowbite-react/lib/esm/components/Navbar/Navbar";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "app/context/useAuth";
import logo from "best-barista-logo.png";
import { useUser } from "app/context/useUser";
import { Dropdown, useThemeMode } from "flowbite-react";
import {
  MdCoffeeMaker,
  MdPlace,
  MdOutlineFlag,
  MdHome,
  MdPayments,
  MdDirectionsCar,
  MdOutlineReply,
  MdBusinessCenter,
  MdPersonOutline,
  MdBusiness,
} from "react-icons/md";
import { TbListTree, TbShoppingCart, TbTemplate } from "react-icons/tb";
import { PiDotOutline } from "react-icons/pi";

import HeaderLink from "./HeaderLink";
import SpaceSwitcher from "./SpaceSwitcher";
import { useCategoriesQuery } from "shared/hooks/categoryApi";
import { SubjectParams } from "shared/utils/pagination";
import { useAddressesQuery } from "shared/hooks/addressApi";

let activeClass = "text-blue-700 dark:text-white underline";
let inactiveClass = "text-slate-600 dark:text-slate-400";
let baseClass = "hover:text-blue-700 cursor-pointer ";

const Header = () => {
  const { token, onLogout } = useAuth();
  const navigate = useNavigate();
  const [mode, , toggleMode] = useThemeMode();

  const logoutHandler = () => {
    onLogout();
    navigate("/auth");
  };

  const { user } = useUser();
  const ability = user.ability;

  const { data: stores } = useAddressesQuery(
    { store: true },
    { skip: ability?.cannot("read", "Product") },
  );
  const { data: categories } = useCategoriesQuery(
    {},
    { skip: ability?.cannot("read", "Product") },
  );

  return (
    <Navbar
      fluid={true}
      rounded={true}
      className="text-slate-600 dark:text-slate-400 print:hidden "
    >
      <Navbar.Brand className="mx-auto md:mx-0" onClick={() => navigate("/")}>
        <img
          src={logo}
          className="-mt-2 mb-2 mr-3 h-9 w-auto lg:h-auto lg:w-32"
          alt="BestBarista Logo"
        />
        {/* {<span className="self-center whitespace-nowrap text-xl font-semibold text-[#b4daff] dark:text-white">
          <span className="text-[#ae6d6c]">Best</span>Barista
        </span>} */}
      </Navbar.Brand>
      <div className="flex items-center md:order-2">
        {token && <SpaceSwitcher />}
        <DarkThemeToggle
          className="mr-4"
          onClick={() => {
            toggleMode();
            let newMode = mode === "dark" ? "light" : "dark";
            localStorage.setItem("theme", newMode);
          }}
        />
        {token && (
          <Button
            size={"xs"}
            gradientDuoTone="purpleToBlue"
            onClick={logoutHandler}
            outline
          >
            Sign Out
          </Button>
        )}
        {!token && (
          <Button
            size={"xs"}
            gradientDuoTone="purpleToBlue"
            onClick={() => navigate("/auth")}
            outline
          >
            Sign In
          </Button>
        )}
        <Navbar.Toggle />
      </div>
      <Navbar.Collapse>
        {!user.email && <HeaderLink title="Home" link="/" />}
        {token && ability?.can("read", "Object") && (
          <HeaderLink
            title={SubjectParams.Address.title}
            link={SubjectParams.Address.url + ""}
          />
        )}
        {token && ability?.can("read", "SnackAddress") && (
          <HeaderLink
            title={SubjectParams.SnackAddress.title}
            link={SubjectParams.SnackAddress.url}
          />
        )}
        {token && ability?.can("read", "Visit") && (
          <HeaderLink
            title={SubjectParams.Visit.title}
            link={SubjectParams.Visit.url}
          />
        )}
        {token && ability?.can("read", "Route") && (
          <HeaderLink
            title={SubjectParams.Route.title}
            link={SubjectParams.Route.url}
          />
        )}
        {token && ability?.can("read", "Order") && (
          <HeaderLink
            title={SubjectParams.Order.title}
            link={SubjectParams.Order.url}
          />
        )}
        {token && ability?.can("read", "Service") && (
          <HeaderLink
            title={SubjectParams.Service.title}
            link={SubjectParams.Service.url}
          />
        )}
        {token &&
          (ability?.can("read", "Location") ||
            ability?.can("read", "Country") ||
            ability?.can("read", "City")) && (
            <Dropdown inline label={"Location"}>
              {ability?.can("read", "Location") && (
                <NavLink
                  to={SubjectParams.Location.url}
                  className={({ isActive }) =>
                    isActive
                      ? baseClass + activeClass
                      : baseClass + inactiveClass
                  }
                >
                  <Dropdown.Item icon={MdPlace}>
                    {SubjectParams.Location.title}
                  </Dropdown.Item>
                </NavLink>
              )}
              {ability?.can("read", "Country") && (
                <NavLink
                  to={SubjectParams.Country.url}
                  className={({ isActive }) =>
                    isActive
                      ? baseClass + activeClass
                      : baseClass + inactiveClass
                  }
                >
                  <Dropdown.Item icon={MdOutlineFlag}>
                    {SubjectParams.Country.title}
                  </Dropdown.Item>
                </NavLink>
              )}
              {ability?.can("read", "City") && (
                <NavLink
                  to={SubjectParams.City.url}
                  className={({ isActive }) =>
                    isActive
                      ? baseClass + activeClass
                      : baseClass + inactiveClass
                  }
                >
                  <Dropdown.Item icon={MdHome}>
                    {SubjectParams.City.title}
                  </Dropdown.Item>
                </NavLink>
              )}
            </Dropdown>
          )}
        {token &&
          (ability?.can("read", "Machine") ||
            ability?.can("read", "Payment") ||
            ability?.can("read", "Car") ||
            ability?.can("read", "Event")) && (
            <Dropdown inline label={"Equipments"}>
              {ability?.can("read", "Machine") && (
                <NavLink
                  to={SubjectParams.Machine.url}
                  className={({ isActive }) =>
                    isActive
                      ? baseClass + activeClass
                      : baseClass + inactiveClass
                  }
                >
                  <Dropdown.Item icon={MdCoffeeMaker}>
                    {SubjectParams.Machine.title}
                  </Dropdown.Item>
                </NavLink>
              )}
              {ability?.can("read", "Payment") && (
                <NavLink
                  to={SubjectParams.Payment.url}
                  className={({ isActive }) =>
                    isActive
                      ? baseClass + activeClass
                      : baseClass + inactiveClass
                  }
                >
                  <Dropdown.Item icon={MdPayments}>
                    {SubjectParams.Payment.title}
                  </Dropdown.Item>
                </NavLink>
              )}
              {ability?.can("read", "Car") && (
                <NavLink
                  to={SubjectParams.Car.url}
                  className={({ isActive }) =>
                    isActive
                      ? baseClass + activeClass
                      : baseClass + inactiveClass
                  }
                >
                  <Dropdown.Item icon={MdDirectionsCar}>
                    {SubjectParams.Car.title}
                  </Dropdown.Item>
                </NavLink>
              )}
            </Dropdown>
          )}
        {token &&
          (ability?.can("read", "Product") ||
            ability?.can("read", "Provider") ||
            ability?.can("read", "Template")) && (
            <Dropdown inline label={"Stock"}>
              {ability?.can("read", "Category") && (
                <NavLink
                  to={SubjectParams.Category.url}
                  className={({ isActive }) =>
                    isActive
                      ? baseClass + activeClass
                      : baseClass + inactiveClass
                  }
                >
                  <Dropdown.Item icon={TbListTree}>
                    {SubjectParams.Category.title}
                  </Dropdown.Item>
                </NavLink>
              )}
              <hr />
              {ability?.can("read", "Product") &&
  stores &&
  Array.isArray(stores) &&
  stores.map((s) => {
    // Group categories by stockId
    const storeCategories = categories && Array.isArray(categories)
      ? categories.filter((c) => c.stockId === s.id)
      : [];
    return (
      <Dropdown.Item key={s.id} icon={PiDotOutline} className="relative group p-0">
        <div className="flex items-center justify-between w-full px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer">
          <span onClick={() => navigate(`${SubjectParams.Address.url}/${s.id}`)}>{s.title}</span>
          {(
            <span className="ml-2 text-slate-500">▶</span>
          )}
        </div>
        {(
          <div className="absolute left-full top-0 mt-0 ml-0 min-w-[180px] bg-white dark:bg-gray-800 shadow-lg z-50 hidden group-hover:block border border-gray-200 dark:border-gray-700 rounded-md">
            {storeCategories.map((c) => (
              <div key={c.id} onClick={() => navigate(`${SubjectParams.Category.url}/${c.id}`)} className="px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-700 cursor-pointer whitespace-nowrap">
                {c.title}
              </div>
            ))}
            <div onClick={() => navigate(`${SubjectParams.Category.url}/create?id=${s.id}`)} className="px-4 py-2 font-light text-sky-500 hover:bg-sky-200 dark:hover:bg-sky-700 cursor-pointer whitespace-nowrap">
                Create
              </div>
          </div>
        )}
        
      </Dropdown.Item>
    );
  })}
              
              <hr />
              {ability?.can("read", "Provider") && (
                <NavLink
                  to={SubjectParams.Provider.url}
                  className={({ isActive }) =>
                    isActive
                      ? baseClass + activeClass
                      : baseClass + inactiveClass
                  }
                >
                  <Dropdown.Item icon={TbShoppingCart}>
                    {SubjectParams.Provider.title}
                  </Dropdown.Item>
                </NavLink>
              )}
              {ability?.can("read", "Template") && (
                <NavLink
                  to={SubjectParams.Template.url}
                  className={({ isActive }) =>
                    isActive
                      ? baseClass + activeClass
                      : baseClass + inactiveClass
                  }
                >
                  <Dropdown.Item icon={TbTemplate}>
                    {SubjectParams.Template.title}
                  </Dropdown.Item>
                </NavLink>
              )}
            </Dropdown>
          )}
        {token && ability?.can("read", "Store") && (
          <HeaderLink
            title={SubjectParams.Store.title}
            link={SubjectParams.Store.url}
          />
        )}
        {token &&
          (ability?.can("read", "Investor") ||
            ability?.can("read", "InvestObject")) && (
            <Dropdown inline label={"Invest"}>
              {token && ability?.can("read", "Investor") && (
                <NavLink
                  to={SubjectParams.Investor.url}
                  className={({ isActive }) =>
                    isActive
                      ? baseClass + activeClass
                      : baseClass + inactiveClass
                  }
                >
                  <Dropdown.Item icon={MdPersonOutline}>
                    {SubjectParams.Investor.title}
                  </Dropdown.Item>
                </NavLink>
              )}
              {token && ability?.can("read", "InvestObject") && (
                <NavLink
                  to={SubjectParams.InvestObject.url}
                  className={({ isActive }) =>
                    isActive
                      ? baseClass + activeClass
                      : baseClass + inactiveClass
                  }
                >
                  <Dropdown.Item icon={MdBusinessCenter}>
                    {SubjectParams.InvestObject.title}
                  </Dropdown.Item>
                </NavLink>
              )}
              {token && ability?.can("read", "InvestObject") && (
                <NavLink
                  to={SubjectParams.InvestGroup.url}
                  className={({ isActive }) =>
                    isActive
                      ? baseClass + activeClass
                      : baseClass + inactiveClass
                  }
                >
                  <Dropdown.Item icon={MdBusiness}>
                    {SubjectParams.InvestGroup.title}
                  </Dropdown.Item>
                </NavLink>
              )}
              {token && ability?.can("read", "Payout") && (
                <NavLink
                  to={SubjectParams.Payout.url}
                  className={({ isActive }) =>
                    isActive
                      ? baseClass + activeClass
                      : baseClass + inactiveClass
                  }
                >
                  <Dropdown.Item icon={MdOutlineReply}>
                    {SubjectParams.Payout.title}
                  </Dropdown.Item>
                </NavLink>
              )}
            </Dropdown>
          )}
        {token &&
          (ability?.can("read", "User") || ability?.can("read", "Role")) && (
            <Dropdown inline label={"Users"}>
              {token && ability?.can("read", "User") && (
                <NavLink
                  to={SubjectParams.User.url}
                  className={({ isActive }) =>
                    isActive
                      ? baseClass + activeClass
                      : baseClass + inactiveClass
                  }
                >
                  <Dropdown.Item icon={MdPersonOutline}>
                    {SubjectParams.User.title}
                  </Dropdown.Item>
                </NavLink>
              )}
              {token && ability?.can("read", "Role") && (
                <NavLink
                  to={SubjectParams.Role.url}
                  className={({ isActive }) =>
                    isActive
                      ? baseClass + activeClass
                      : baseClass + inactiveClass
                  }
                >
                  <Dropdown.Item icon={MdPersonOutline}>
                    {SubjectParams.Role.title}
                  </Dropdown.Item>
                </NavLink>
              )}
            </Dropdown>
          )}
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Header;
